import { memo, useEffect, useState, useContext, useRef } from 'react';
import { TiPlus, TiMinus } from "react-icons/ti";

import '../css/options.css'

export default function Number({ qnt, onChange, value }) {

    let ref = useRef(false);
    if (!qnt) {
        qnt = 999999999;
    }
    
    function plusMin(p) {
        
        if (p) {
            onChange({ _id:'qnt', val: value <= 0 ? 0 : value - 1 });
        } else {
            onChange({_id:'qnt', val: value >= qnt ? qnt : value + 1});
        }
    }
    
  
    return (
        <div className='productNumberBox'>

            <a onClick={() => plusMin(true)}>
                <TiMinus />
            </a>
            <input type='number' onWheel={(e) => e.target.blur()} name='numb' onChange={(e) => onChange({ _id:'qnt', val:parseInt(e.target.value) >= qnt ? qnt : parseInt(e.target.value) })} onBlur={(e) => onChange({ _id:'qnt', val:parseInt(e.target.value) >= qnt ? qnt : parseInt(e.target.value) })} value={value}/>
            <a onClick={() => plusMin()}>
                <TiPlus />
            </a>
            
            
        </div>
    );
}
